import { HttpClientBoltServer } from '@bolteu/http-client-bolt-server';
import { DriverRegistrationPortalNoAuthService } from '@gen/driverRegistration/driverRegistrationPortalNoAuth';
import { getAppBrand, getServerHost } from '../common/environment';

const driverRegistrationHttpClient =
  new HttpClientBoltServer<DriverRegistrationPortalNoAuthService.HttpClientConstraints>(
    {
      baseUrl: getServerHost(),
    }
  );

driverRegistrationHttpClient.init({
  standardRequestStrategy: {
    getStandardRequest: () => {
      return {
        brand: getAppBrand(),
      };
    },
  },
});

const driverRegistrationApiClient =
  new DriverRegistrationPortalNoAuthService.ApiClient({
    httpClient: driverRegistrationHttpClient,
  });

export default driverRegistrationApiClient;
